document.addEventListener('DOMContentLoaded', () => {
	if (typeof dfAjax === 'undefined') return;

	const filters = document.querySelectorAll('.category-filter[data-ajax-target]');
	if (!filters.length) return;

	filters.forEach((filter) => {
		const target = document.getElementById(filter.dataset.ajaxTarget);
		const count = filter.dataset.ajaxCount || 6;
		const toggle = filter.querySelector('.category-filter-toggle');
		const label = filter.querySelector('.category-filter-label');
		const links = filter.querySelectorAll('.category-filter-menu a');
		if (!target) return;

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				if (link.classList.contains('is-active')) {
					filter.classList.remove('is-active');
					return;
				}

				const term = link.dataset.term || '';
				const termName = link.dataset.termName || 'CATEGORY';

				const body = new URLSearchParams();
				body.append('action', 'df_filter_projects');
				body.append('nonce', dfAjax.nonce);
				body.append('term', term);
				body.append('count', count);

				target.classList.add('is-loading');

				fetch(dfAjax.url, { method: 'POST', body })
					.then((res) => res.json())
					.then((res) => {
						if (res.success) {
							target.innerHTML = res.data.html;
						}
					})
					.finally(() => {
						target.classList.remove('is-loading');
					});

				links.forEach((l) => l.classList.remove('is-active'));
				link.classList.add('is-active');
				if (label) label.textContent = termName;

				filter.classList.remove('is-active');
				toggle?.setAttribute('aria-expanded', 'false');
			});
		});
	});
});
